/** Product dark surface — keep Telegram chrome in sync with DESIGN.md. */
const TG_BG = '#0c0e14'

type TelegramWebApp = {
  ready?: () => void
  expand?: () => void
  setHeaderColor?: (color: string) => void
  setBackgroundColor?: (color: string) => void
  disableVerticalSwipes?: () => void
  HapticFeedback?: {
    impactOccurred?: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void
  }
}

function getLegacyWebApp(): TelegramWebApp | undefined {
  try {
    return (
      window as unknown as { Telegram?: { WebApp?: TelegramWebApp } }
    ).Telegram?.WebApp
  } catch {
    return undefined
  }
}

/**
 * Align Mini App chrome with product surface. Safe no-op outside Telegram.
 */
export function bootstrapTelegramUI(bg: string = TG_BG): void {
  try {
    const tg = getLegacyWebApp()
    if (!tg) return
    tg.ready?.()
    tg.expand?.()
    tg.setHeaderColor?.(bg)
    tg.setBackgroundColor?.(bg)
    tg.disableVerticalSwipes?.()
  } catch {
    /* ignore */
  }
}

export function hapticLight(): void {
  try {
    getLegacyWebApp()?.HapticFeedback?.impactOccurred?.('light')
  } catch {
    /* ignore */
  }
}
